
















import ActivityFile from '@/domain/schedule/activitie/activity-file.entity';
import ActivityService from '@/domain/schedule/activitie/activity.service';
import { VbSnackbarService } from 'bag-of-holding-library';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ActivityFileItemComponent extends Vue {
  @Prop({
    type: ActivityFile,
    required: true,
  }) file!: ActivityFile;

  @Prop({
    type: String,
    required: true,
  }) activityId!: string;

  getFile() {
    this.file.loadingDownload = true;
    ActivityService.getFile(this.activityId, this.file.id)
      .then((response: any) => {
        const { data } = response;
        const blob = new Blob([data], { type: '*/*' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.target = '_blank';
        link.download = this.file.originalName;
        link.click();
      })
      .catch((e) => {
        if (this.file.url) {
          window.open(this.file.url, '_blank');
          return;
        }
        VbSnackbarService.handleHttpError(e)
      })
      .finally(() => {
        this.file.loadingDownload = false;
      })
  }
}
